import { FileText, UserCheck, Video } from "lucide-react";
export const SocialProofSection = () => (
  <section id="testimonials" className="recruit-trust recruit-section">
    <div className="recruit-shell">
      <p className="recruit-eyebrow">Designed for considered decisions</p>
      <h2>More context. Still your call.</h2>
      <div className="recruit-trust-grid">
        {[
          {
            icon: FileText,
            title: "Sources, not certainty",
            body: "A linked passage helps you inspect what was written or said. It is not independent verification.",
          },
          {
            icon: Video,
            title: "Availability stays visible",
            body: "Not every candidate has a published intro or completed interview. Review the information that is available.",
          },
          {
            icon: UserCheck,
            title: "People make the decision",
            body: "Use AI to support your review. Follow up on gaps and make hiring decisions with your team.",
          },
        ].map(({ icon: Icon, title, body }) => (
          <div key={title}>
            <Icon size={22} />
            <h3>{title}</h3>
            <p>{body}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
